interface BackgroundProps {
  primaryColor?: string
  useGradient?: boolean
}

export const Background = ({
  primaryColor = "#2B5FF5",
  useGradient = false,
}: BackgroundProps) => {
  const gradientId = "bubbleGradient"

  return (
    <svg
      width="102%"
      height="56"
      viewBox="0 0 375 56"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {useGradient && (
        <defs>
          <linearGradient
            id={gradientId}
            x1="0"
            y1="28"
            x2="375"
            y2="28"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="var(--ultimate-gradient-start)" />
            <stop offset="1" stopColor="var(--ultimate-gradient-end)" />
          </linearGradient>
        </defs>
      )}
      <path
        d="M187.311 26.5328C113.667 26.5328 0.439337 0.852783 0.439337 0.852783L0 56H194.554H375L374.183 0.852783C374.183 0.852783 260.954 26.5328 187.311 26.5328Z"
        fill={useGradient ? `url(#${gradientId})` : primaryColor}
      />
      <path
        d="M187.28 26.5084C113.435 26.4861 0 0 0 0V26.5084C0 26.5084 113.638 48.856 187.28 48.8749C261.08 48.8938 374.967 26.5084 374.967 26.5084V0C374.967 0 261.282 26.5308 187.28 26.5084Z"
        fill={
          useGradient
            ? "var(--ultimate-wave-overlay-1)"
            : "var(--wave-background-primary)"
        }
        fillOpacity="0.5"
      />
      <path
        d="M187.312 26.5328C113.467 26.5551 0.0322266 53.0413 0.0322266 53.0413V26.5328C0.0322266 26.5328 113.67 4.18522 187.312 4.16636C261.112 4.14746 375 26.5328 375 26.5328V53.0413C375 53.0413 261.314 26.5105 187.312 26.5328Z"
        fill={
          useGradient
            ? "var(--ultimate-wave-overlay-2)"
            : "var(--wave-background-secondary)"
        }
        fillOpacity="0.5"
      />
    </svg>
  )
}

interface FeaturesProps {
  trashRecovery?: string
  noAds?: string
  spaceSaver?: string
  cloudVault?: string
  everyPremiumFeature?: string
}

export const Features = ({
  trashRecovery = "Trash recovery",
  noAds = "No ads",
  spaceSaver = "Space Saver",
  cloudVault = "Cloud Vault",
  everyPremiumFeature = "Get every\nPremium feature",
}: FeaturesProps = {}) => {
  return (
    <svg
      width="322"
      height="271"
      viewBox="0 0 322 271"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style>
          {`
            @font-face {
              font-family: "RedHatDisplay";
              src: url("../../public/fonts/RedHatDisplay-Regular.ttf") format("truetype");
              font-weight: 400;
              font-style: normal;
            }
            @font-face {
              font-family: "RedHatDisplay";
              src: url("../../public/fonts/RedHatDisplay-SemiBold.ttf") format("truetype");
              font-weight: 600;
              font-style: normal;
            }
            @font-face {
              font-family: "RedHatDisplay";
              src: url("../../public/fonts/RedHatDisplay-Bold.ttf") format("truetype");
              font-weight: bold;
              font-style: normal;
            }
            @font-face {
              font-family: "RedHatDisplay";
              src: url("../../public/fonts/RedHatDisplay-Black.ttf") format("truetype");
              font-weight: 900;
              font-style: normal;
            }
          `}
        </style>
        <clipPath id="clip0_25529_1552">
          <rect
            width="38"
            height="38"
            fill="white"
            transform="translate(140.3 119.16)"
          />
        </clipPath>
      </defs>
      <rect
        x="27.6826"
        y="18.3582"
        width="52.175"
        height="52.175"
        rx="26.0875"
        fill="white"
        fillOpacity="0.15"
      />
      <path
        d="M50.7352 50.3906C50.7352 50.7994 50.3718 51.1173 50.0085 51.1173C49.5998 51.1173 49.2819 50.7994 49.2819 50.3906V40.9443C49.2819 40.581 49.5998 40.2177 50.0085 40.2177C50.3718 40.2177 50.7352 40.581 50.7352 40.9443V50.3906ZM54.3684 50.3906C54.3684 50.7994 54.005 51.1173 53.6417 51.1173C53.233 51.1173 52.9151 50.7994 52.9151 50.3906V40.9443C52.9151 40.581 53.233 40.2177 53.6417 40.2177C54.005 40.2177 54.3684 40.581 54.3684 40.9443V50.3906ZM58.0016 50.3906C58.0016 50.7994 57.6383 51.1173 57.2749 51.1173C56.8662 51.1173 56.5483 50.7994 56.5483 50.3906V40.9443C56.5483 40.581 56.8662 40.2177 57.2749 40.2177C57.6383 40.2177 58.0016 40.581 58.0016 40.9443V50.3906ZM57.8653 33.36L59.5457 35.8578H62.7247C63.3151 35.8578 63.8147 36.3574 63.8147 36.9478C63.8147 37.5836 63.3151 38.0377 62.7247 38.0377H62.3614V51.8439C62.3614 53.8876 60.7265 55.4771 58.7282 55.4771H48.5552C46.5116 55.4771 44.922 53.8876 44.922 51.8439V38.0377H44.5587C43.9229 38.0377 43.4688 37.5836 43.4688 36.9478C43.4688 36.3574 43.9229 35.8578 44.5587 35.8578H47.6924L49.3727 33.36C49.8269 32.6788 50.6443 32.2246 51.5072 32.2246H55.7308C56.5937 32.2246 57.4112 32.6788 57.8653 33.36ZM50.3264 35.8578H56.9116L56.0487 34.5862C56.0033 34.4954 55.8671 34.4045 55.7308 34.4045H51.5072C51.371 34.4045 51.2347 34.4954 51.1893 34.5862L50.3264 35.8578ZM47.102 51.8439C47.102 52.6614 47.7378 53.2972 48.5552 53.2972H58.7282C59.5003 53.2972 60.1815 52.6614 60.1815 51.8439V38.0377H47.102V51.8439Z"
        fill="white"
      />
      <text
        fill="#1D212B"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="RedHatDisplay"
        fontSize="12"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="13.3581" y="87.3718">
          {trashRecovery}
        </tspan>
      </text>
      <text
        fill="white"
        fillOpacity="0.9"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="RedHatDisplay"
        fontSize="12"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="13.3581" y="87.3718">
          {trashRecovery}
        </tspan>
      </text>
      <rect
        x="253.86"
        y="177.99"
        width="45.8386"
        height="45.8386"
        rx="22.9193"
        fill="white"
        fillOpacity="0.15"
      />
      <path
        d="M287.463 200.633C287.463 206.462 282.743 211.141 276.956 211.141C271.127 211.141 266.448 206.462 266.448 200.633C266.448 194.846 271.127 190.126 276.956 190.126C282.743 190.126 287.463 194.846 287.463 200.633ZM270.224 195.339C269.075 196.816 268.418 198.663 268.418 200.633C268.418 205.354 272.236 209.171 276.956 209.171C278.926 209.171 280.773 208.514 282.25 207.365L270.224 195.339ZM285.493 200.633C285.493 195.954 281.635 192.096 276.956 192.096C274.944 192.096 273.097 192.794 271.62 193.943L283.646 205.969C284.795 204.492 285.493 202.645 285.493 200.633Z"
        fill="white"
      />
      <text
        fill="#1D212B"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="RedHatDisplay"
        fontSize="12"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="257.878" y="240.667">
          {noAds}
        </tspan>
      </text>
      <text
        fill="white"
        fillOpacity="0.9"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="RedHatDisplay"
        fontSize="12"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="257.878" y="240.667">
          {noAds}
        </tspan>
      </text>
      <circle
        cx="232.271"
        cy="158.244"
        r="13.319"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="0.966204"
      />
      <circle
        cx="311.738"
        cy="135.233"
        r="8.95626"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="0.966204"
      />
      <circle
        cx="95.8972"
        cy="122.371"
        r="5.79204"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="0.966204"
      />
      <rect
        x="18.9873"
        y="164.99"
        width="61.5852"
        height="61.5852"
        rx="30.7926"
        fill="white"
        fillOpacity="0.15"
      />
      <path
        d="M55.1904 195.43L60.9683 189.813"
        stroke="white"
        strokeWidth="2.20031"
        strokeLinecap="round"
      />
      <path
        d="M60.9736 189.803V196.408"
        stroke="white"
        strokeWidth="2.20031"
        strokeLinecap="round"
      />
      <path
        d="M60.9131 189.803H54.2942"
        stroke="white"
        strokeWidth="2.20031"
        strokeLinecap="round"
      />
      <path
        d="M45.085 199.889L39.307 205.506"
        stroke="white"
        strokeWidth="2.20031"
        strokeLinecap="round"
      />
      <path
        d="M39.3008 205.516V198.911"
        stroke="white"
        strokeWidth="2.20031"
        strokeLinecap="round"
      />
      <path
        d="M39.3614 205.516H45.9802"
        stroke="white"
        strokeWidth="2.20031"
        strokeLinecap="round"
      />
      <path
        d="M41.0664 195.751V185.221C41.0664 184.123 41.9568 183.232 43.055 183.232H57.2142C58.3125 183.232 59.2028 184.123 59.2028 185.221V186.484"
        stroke="white"
        strokeWidth="2.20031"
        strokeLinecap="round"
      />
      <path
        d="M59.2026 199.282V209.812C59.2026 210.911 58.3123 211.801 57.214 211.801H43.055C41.9568 211.801 41.0664 210.911 41.0664 209.812V208.27"
        stroke="white"
        strokeWidth="2.20031"
        strokeLinecap="round"
      />
      <text
        fill="#1D212B"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="RedHatDisplay"
        fontSize="12"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="15.8779" y="243.414">
          {spaceSaver}
        </tspan>
      </text>
      <text
        fill="white"
        fillOpacity="0.9"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="RedHatDisplay"
        fontSize="12"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="15.8779" y="243.414">
          {spaceSaver}
        </tspan>
      </text>
      <rect
        x="227.027"
        width="68.952"
        height="68.952"
        rx="34.476"
        fill="white"
        fillOpacity="0.15"
      />
      <path
        d="M271.561 45.6524H252.285C248.095 45.6524 244.742 42.3 244.742 38.1096C244.742 34.862 246.837 32.0335 249.771 31.0383V30.9859C249.771 26.1669 253.699 22.186 258.571 22.186C261.19 22.186 263.599 23.3908 265.223 25.2765C266.009 24.9098 266.847 24.7003 267.789 24.7003C271.247 24.7003 274.075 27.5288 274.075 30.9859C274.075 31.3526 274.023 31.6669 273.97 32.0335C276.485 33.1335 278.266 35.6477 278.266 38.5287C278.266 42.3524 275.28 45.4428 271.561 45.6524ZM264.542 28.3145L263.285 26.9003C262.132 25.5907 260.456 24.7003 258.571 24.7003C255.061 24.7003 252.285 27.5288 252.285 30.9859V32.8192L250.556 33.3954C248.618 34.0763 247.256 35.962 247.256 38.1096C247.256 40.8858 249.456 43.1381 252.285 43.1381H271.404C273.813 43.0334 275.751 40.9905 275.751 38.5287C275.751 36.643 274.599 35.0192 272.975 34.3382L271.194 33.5525L271.508 31.6145C271.508 31.4049 271.561 31.1954 271.561 30.9859C271.561 28.9431 269.832 27.2145 267.789 27.2145C267.213 27.2145 266.689 27.3717 266.218 27.5812L264.542 28.3145Z"
        fill="white"
      />
      <text
        fill="#1D212B"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="RedHatDisplay"
        fontSize="12"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="229.886" y="85.7907">
          {cloudVault}
        </tspan>
      </text>
      <text
        fill="white"
        fillOpacity="0.9"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="RedHatDisplay"
        fontSize="12"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="229.886" y="85.7907">
          {cloudVault}
        </tspan>
      </text>
      <rect
        x="117.289"
        y="96.6206"
        width="83.5922"
        height="83.5922"
        rx="41.7961"
        fill="white"
        fillOpacity="0.15"
      />
      <g clipPath="url(#clip0_25529_1552)">
        <path
          d="M173.428 121.619H169.946C169.878 120.247 168.74 119.16 167.351 119.16H151.229C149.841 119.16 148.703 120.247 148.635 121.619H145.152C143.74 121.619 142.591 122.78 142.591 124.207V130.803C142.591 131.737 143.045 132.851 143.696 133.511L145.508 135.349C146.166 136.017 147.282 136.484 148.221 136.484H148.626V137.381C148.626 138.692 149.483 140.288 150.574 141.016L156.151 144.722L155.353 149.56H151.695C151.127 149.56 150.584 149.984 150.433 150.531L148.941 155.903C148.854 156.217 148.91 156.536 149.094 156.779C149.279 157.022 149.572 157.16 149.898 157.16H168.683C169.009 157.16 169.301 157.024 169.486 156.781C169.671 156.539 169.727 156.221 169.639 155.907L168.148 150.53C167.996 149.983 167.453 149.56 166.886 149.56H163.227L162.427 144.722L168.016 141.01C169.107 140.283 169.973 138.692 169.973 137.381V136.484H170.359C171.301 136.484 172.419 136.017 173.076 135.351L174.894 133.511C175.55 132.845 176.009 131.732 176.009 130.803V124.207C176.008 122.78 174.851 121.619 173.428 121.619ZM148.626 133.131H148.236C148.144 133.119 147.958 133.042 147.885 132.985L146.095 131.168C146.035 131.09 145.954 130.889 145.944 130.792V124.972H148.626V133.131H148.626ZM165 129.995L162.471 131.845C162.073 132.134 161.872 132.76 162.024 133.228L162.99 136.204C163.142 136.672 162.94 136.82 162.543 136.531L160.014 134.694C159.616 134.405 158.965 134.405 158.567 134.694L156.037 136.532C155.64 136.821 155.438 136.675 155.59 136.207L156.556 133.234C156.708 132.767 156.507 132.147 156.109 131.858L153.58 129.994C153.182 129.705 153.259 129.442 153.751 129.442H156.877C157.369 129.442 157.896 129.086 158.048 128.619L159.014 125.659C159.166 125.191 159.415 125.198 159.567 125.665L160.532 128.615C160.684 129.083 161.211 129.442 161.703 129.442H164.829C165.321 129.443 165.398 129.705 165 129.995ZM172.656 130.788C172.643 130.887 172.559 131.088 172.497 131.166L170.701 132.984C170.626 133.041 170.438 133.119 170.345 133.131H169.973V124.972H172.656V130.788Z"
          fill="white"
        />
      </g>
      <text
        fill="#1D212B"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="RedHatDisplay"
        fontSize="12"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="130.703" y="197.051">
          {everyPremiumFeature.split("\n")[0]}
        </tspan>
        <tspan x="113.172" y="214.443">
          {everyPremiumFeature.split("\n")[1]}
        </tspan>
      </text>
      <text
        fill="white"
        fillOpacity="0.9"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="RedHatDisplay"
        fontSize="12"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="130.703" y="197.051">
          {everyPremiumFeature.split("\n")[0]}
        </tspan>
        <tspan x="113.172" y="214.443">
          {everyPremiumFeature.split("\n")[1]}
        </tspan>
      </text>
      <circle
        cx="188.417"
        cy="50.489"
        r="6.056"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="0.966204"
      />
      <circle
        cx="121.952"
        cy="239.887"
        r="5.31412"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="0.966204"
      />
      <circle
        cx="196.845"
        cy="246.029"
        r="19.0586"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="0.966204"
      />
      <circle
        cx="10.6282"
        cy="129.395"
        r="10.1451"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="0.966204"
      />
      <circle
        cx="110.008"
        cy="19.2478"
        r="11.1113"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="0.966204"
      />
    </svg>
  )
}
